import React, { useState, memo, useEffect, useMemo, useContext } from "react";
import {
  Row,
  Container,
  Card,
  CardBody,
  Col,
  Table,
  Button,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import moment from "moment";
// Pages
import Breadcrumbs from "../../components/common/Breadcrumb";
import { useAppSettings } from '../../contexts/AppSettingsContext';
import {
    handleAddEditCustomerApi,
    getAllCustomersDetailsApi,
    handleChangeCustomerStatusApi,
    fetchSingleCustomerDetailsApi
} from "../../api/customerApi";
import { AuthContext } from "../../contexts/AuthContext";
import PaginationComponent from "../../components/common/Pagination";

function Customers() {
  const { appSettings } = useAppSettings();
  const itemsPerPage = process.env.REACT_APP_PAGINATION_ITEMS_PER_PAGE;  

  const appName = appSettings?.title ||process.env.REACT_APP_APP_NAME;
  const [customerModal, setCustomerModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [customers, setCustomers] = useState([]);
  const [singleCustomerDetails, setSingleCustomerDetails] = useState({});
  const [popUpMode, setPopUpMode] = useState("");
  const { authToken } = useContext(AuthContext);
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0);
 

  // Set token
  useEffect(() => {
    if (authToken) {
      fetchAllCustomers(currentPage);
    }
  }, [authToken, currentPage]);

  // Function handle open & close modal
  const toggle = () => {
    setCustomerModal(!customerModal);
    if (!customerModal) {
      // # Reset form to initial values when modal is closed
      customerForm.resetForm();
      setErrorMessage("");
      setSuccessMessage("");
      setSingleCustomerDetails([]);
    }
  };

  // #Handle customer form
  const customerForm = useFormik({
    enableReinitialize : true,
    initialValues: {
      name: singleCustomerDetails?.name || "",
      image: singleCustomerDetails?.image || null,
      email: singleCustomerDetails?.email ||"",
      contact_no: singleCustomerDetails?.contact_no || "",
      emergency_contact_no: singleCustomerDetails?.emergency_contact_no || "",
      address: singleCustomerDetails?.address ||  "",
      id_proof: singleCustomerDetails?.id_proof ||  null
    },
    validationSchema : Yup.object({
      contact_no: Yup.string().matches(/^\S+$/, "Spaces are not allowed"),
      emergency_contact_no: Yup.string().matches(/^\S+$/, "Spaces are not allowed"),
    }),
    onSubmit: (values) => {
      values.isEdit  = false
      if(popUpMode == 'EDIT'){
        const customerId = singleCustomerDetails?.id
        values.isEdit  = true
        values.id   = customerId
      }
      console.log("submitted values ->", values);
      handleAddOrEditCustomer(values);
      setSuccessMessage("");
    },
  });


  // Function handle  add or edit customer  functionality
  async function handleAddOrEditCustomer(values) {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }

      let response = await handleAddEditCustomerApi(values, authToken);
      if (response?.code == 200) {
        setErrorMessage("");
        setSuccessMessage(response.message);
        fetchAllCustomers(authToken);
        setCustomerModal(false);
      } else {
        setSuccessMessage("");
        setErrorMessage(response?.message || "");
      }
    } catch (error) {
      console.log(error.message);
      setSuccessMessage("");
      setErrorMessage("Something went wrong");
    }
  }

  // Function for fetch all customers
  async function fetchAllCustomers() {
    try {
      let response = await getAllCustomersDetailsApi(authToken, currentPage, itemsPerPage);
      const responseData  =  response?.data
      if (response?.code == 200) {
        setCustomers(responseData.customers || []);
        setTotalPages(Math.ceil((responseData.totalCount || 1) / itemsPerPage));
      }
    } catch (err) {
      console.log("err->", err.message);
    }
  }

    // Function for change user status 
    const handleChangeCustomerStatus = async(customerId) =>{
      try{
  
        let response = await handleChangeCustomerStatusApi(customerId, authToken);
        if (response?.code == 200) {
              const updatedCustomers = customers?.map((item)=>
                customerId == item.id ?  {...item,status : item.status == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'} : item)
              setCustomers(updatedCustomers)
        } 
      }catch(error){
          console.log("error",error);
      }
    }
  
    // Function for fetch single  customer details based on the  customer id 
    const fetchSingleCustomerDetails= async(userId) =>{
      try{
        if (!authToken) {
          throw new Error("Token not found.");
        }
        let response = await fetchSingleCustomerDetailsApi(authToken, userId);
        if (response?.code == 200) {
          toggle();
          setSingleCustomerDetails(response?.data || []);
        }
        setPopUpMode("EDIT");
      
      }catch(err){
        console.log("err",err.message);
      }
    }

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs title={appName} breadcrumbItem="Customers" />
        <Row>
          <Col lg={12}>
            <Card>
              <CardHeader tag="h5" className="p-1 ">
                <Button color="success" onClick={toggle}>
                  Add Customers
                </Button>
              </CardHeader>
              <MemoisedProductOpenPopUp
                customerModal={customerModal}
                toggle={toggle}
                customerForm={customerForm}
                errorMessage={errorMessage}
                successMessage={successMessage}
                popUpMode={popUpMode}
              />
              <CardBody>
                <Table striped>
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Name</th>
                      <th>Image</th>
                      <th>Email</th>
                      <th>Contact no</th>
                      <th>Created at</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {customers?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.name}</td>
                        <td >
                           <img className="listItemImage" src={item.image} alt={`${item.name}  image `}/>
                        </td>
                        <td>{item.email}</td>
                        <td>{item.contact_no}</td>
                        <td style={{ whiteSpace: 'nowrap' }}>
                          {moment(item.created_at).format('DD MMM YYYY')}
                        </td>
                        <td>
                          <Button color={`${item.status == 'ACTIVE' ? 'success' : 'danger'}`} type="button" onClick={()=>{handleChangeCustomerStatus(item.id)}}>
                            {item.status}
                          </Button>
                        </td>
                        <td>
                          <Button  color={`success`} type="button" onClick={()=>{fetchSingleCustomerDetails(item.id)}}>
                            Edit
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
              <div  className=" d-flex justify-content-end">
                <PaginationComponent currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages}/>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Customers;

const OpenPopUp = ({
  customerModal,
  toggle,
  customerForm,
  errorMessage,
  successMessage,
  popUpMode
}) => {
  return (
    <div>
      <Modal size="xl" isOpen={customerModal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{ popUpMode !== 'EDIT' ? 'Add Customers' : 'Edit Customers'}</ModalHeader>
        <Form onSubmit={customerForm.handleSubmit}>
          <ModalBody>
            <Row>
              <Col md={12}>
                {errorMessage && (
                  <span className=" invalidError d-flex justify-content-center">
                    {errorMessage}
                  </span>
                )}
                {successMessage && (
                  <span className=" successMsg d-flex justify-content-center">
                    {successMessage}
                  </span>
                )}
              </Col>
              <Col md={12}>
                <FormGroup>
                  <Label htmlFor="customer_name">Name:</Label>
                  <Input
                    type="text"
                    value={customerForm.values.name}
                    required
                    onChange={customerForm.handleChange}
                    id="customer_name"
                    name="name"
                  />
                </FormGroup>
              </Col>
              <Col md={8}>
                <FormGroup>
                  <Label htmlFor="customer_image">Image:</Label>
                  {customerForm.values?.image && (
                    <img
                      src={typeof customerForm.values?.image == 'string' ? customerForm.values?.image :  URL.createObjectURL(customerForm.values?.image)}
                      alt="Image Preview"
                      className="productImagePreview"
                    />
                  )}
                  <Input
                    type="file"
                    id="customer_image"
                    required={typeof customerForm.values?.image !== 'string' }
                    onChange={(event) =>{
                     const file = event.target.files[0]
                     if(file && (file.type ==="image/jpeg" || file.type === "image/png")){
                        customerForm.setFieldValue('image',file)
                     }else{
                        event.target.value = null;
                        if(!(customerForm.values?.image instanceof File)){
                          customerForm.setFieldError("image", "Only JPG or PNG files are allowed.");
                        }
                     } 
                    }}
                    name="image"
                  />
                  {customerForm.errors.image && (
                    <div className="invalidError d-flex justify-content-center">{customerForm.errors.image}</div>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <FormGroup>
                  <Label htmlFor="customer_email">Email:</Label>
                  <Input
                    type="email"
                    id="customer_email"
                    value={customerForm.values.email}
                    required
                    onChange={customerForm.handleChange}
                    name="email"
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label htmlFor="customer_no">Contact Number:</Label>
                  <Input
                    type="text"
                    id="customer_no"
                    value={customerForm.values.contact_no}
                    required
                    onChange={customerForm.handleChange}
                    name="contact_no"
                  />
                </FormGroup>
                {customerForm.errors.contact_no &&
                  customerForm.errors.contact_no ? (
                    <div className=" invalidError d-flex justify-content-center">
                      {customerForm.errors.contact_no}
                    </div>
                  ) : null}
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label htmlFor="emergency_contact_no">
                    Emergency Contact Number:
                  </Label>
                  <Input
                    type="text  "
                    id="emergency_contact_no"
                    value={customerForm.values.emergency_contact_no}
                    required
                    onChange={customerForm.handleChange}
                    name="emergency_contact_no"
                  />
                </FormGroup>
                {customerForm.errors.emergency_contact_no &&
                  customerForm.errors.emergency_contact_no ? (
                    <div className=" invalidError d-flex justify-content-center">
                      {customerForm.errors.emergency_contact_no}
                    </div>
                  ) : null}
              </Col>
              <Col md={8}>
                <FormGroup>
                  <Label htmlFor="customer_id_proof ">Id Proof:</Label>
                  {customerForm.values?.id_proof && (
                    <img
                      src={typeof customerForm.values?.id_proof == 'string' ? customerForm.values?.id_proof :  URL.createObjectURL(customerForm.values?.id_proof)}
                      alt="id proof Preview"
                      className="productImagePreview"
                    />
                  )}
                  <Input
                    type="file"
                    id="customer_id_proof"
                    required={typeof customerForm.values?.id_proof !== 'string' }
                    onChange={(event) => {
                      const file = event.currentTarget.files[0];
                      if (file && (file.type === "image/jpeg" || file.type === "image/png")) {
                        customerForm.setFieldValue("id_proof", file);
                      } else {
                        event.target.value = null;
                        if(!(customerForm.values?.id_proof instanceof File)){
                          customerForm.setFieldError("id_proof", "Only JPG or PNG files are allowed.");
                        }
            
                      }
                    }}
                    name="id_proof"
                  />
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <Label htmlFor="customer_address">Address</Label>
                  <textarea
                    className="selectInput"
                    id="customer_address"
                    name="address"
                    value={customerForm.values.address}
                    required
                    onChange={customerForm.handleChange}
                  />
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="primary">
              Submit
            </Button>
            {/* </FormGroup> */}
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};
const MemoisedProductOpenPopUp = memo(OpenPopUp);
